import { createFileRoute } from '@tanstack/react-router'
import ResetPassword from "@views/auth/ResetPassword.tsx";

type ResetPasswordSearch = {
  token?: string;
};

export const Route = createFileRoute('/_public/reset-password/')({
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => ({
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  component: ResetPasswordPage,
})

function ResetPasswordPage() {
  const { token } = Route.useSearch();
  return <ResetPassword token={token} />;
}

